function redraw(element) {
    element.forEach(function(element) {
        let items = element.querySelectorAll('.js-unify-height2-item');
        let height = -1;

        items.forEach(function (element) {
            element.style.height = '';
        });

        items.forEach(function (element) {
            if(height < element.offsetHeight) {
                height = element.offsetHeight;
            }
        });

        items.forEach(function (element) {
            element.style.height = height+'px';
        });
    });
}

export function applyTo(selector) {
    let elements = document.querySelectorAll(selector);

    redraw(elements);

    window.addEventListener('resize', function() {
        redraw(elements);
    });
}
